// 로그인, 회원 가입, 회원 탈퇴
import { instance } from './index'

//로그인 API
function loginUser (url, userData) {
  return instance.post(url, userData)
}

export { loginUser }